var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"icon",class:_vm.iconClass,attrs:{"id":"header-logo","role":"img","aria-label":_vm.altText}})
}
var staticRenderFns = []

export { render, staticRenderFns }